import React, { useState } from "react";
import { Trash2, RotateCcw, XCircle } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

function Confirm({ trigger, title, text, action, danger, onConfirm }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent className="bg-slate-900 border-slate-800 text-slate-100">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">{text}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="button-confirm-cancel" className="bg-slate-800 border-slate-700 hover:bg-slate-700 text-slate-100">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="button-confirm-ok" onClick={onConfirm} className={danger ? "bg-rose-600 hover:bg-rose-500" : "bg-blue-600 hover:bg-blue-500"}>{action}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export const ShipmentAdminActions = ({ sh, archived, onDone }) => {
  const [busy, setBusy] = useState(false);
  const run = async (req, msg) => {
    setBusy(true);
    try { await req(); toast.success(msg); onDone(); } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };
  const btn = (testid, Icon, label, cls) => (
    <Button data-testid={testid} size="sm" variant="ghost" disabled={busy} className={`h-7 px-2 ${cls}`}><Icon size={14} className="mr-1" /> {label}</Button>
  );

  if (!archived) {
    return (
      <Confirm trigger={btn(`button-delete-${sh.shipment_number}`, Trash2, "Delete", "text-rose-300 hover:bg-rose-500/10")}
               title={`Delete ${sh.shipment_number}?`} action="Move to Archive" danger
               text="The shipment moves to the Archive. It disappears from the folders, Dashboard and Finance lists, and its client link stops working. You can restore it from the Archive."
               onConfirm={() => run(() => api.delete(`/shipments/${sh.id}`), `${sh.shipment_number} moved to Archive`)} />
    );
  }
  return (
    <div className="flex gap-1 justify-end">
      <Confirm trigger={btn(`button-restore-${sh.shipment_number}`, RotateCcw, "Restore", "text-sky-300 hover:bg-sky-500/10")}
               title={`Restore ${sh.shipment_number}?`} action="Restore"
               text="The shipment returns to its folder with all its data."
               onConfirm={() => run(() => api.post(`/shipments/${sh.id}/restore`), `${sh.shipment_number} restored`)} />
      <Confirm trigger={btn(`button-delete-permanent-${sh.shipment_number}`, XCircle, "Delete permanently", "text-rose-300 hover:bg-rose-500/10")}
               title={`Permanently delete ${sh.shipment_number}?`} action="Delete permanently" danger
               text="This removes the shipment and its invoice for good. It cannot be undone. Finance records such as collections, fund requests and liquidations are kept."
               onConfirm={() => run(() => api.delete(`/shipments/${sh.id}/permanent`), `${sh.shipment_number} permanently deleted`)} />
    </div>
  );
};
